<template>
  <div class="freeRunning-main">
    <div class="free-main-item" v-for='(item,index) in freeitems' :key='index' @click='detail(item.id,item.faceimg)'>
        <div class="free-main-item-left">
            <img :src="item.faceimg" alt="">
        </div>
        <div class="free-main-item-right">
            <div class="free-main-item-right-one">{{item.title}}</div>
            <div class="free-main-item-right-two">{{item.traveldate}}月出行<span class='sline'>|</span>{{item.photonum}}张照片</div>
            <div class="free-main-item-right-three">{{item.introduce}}</div>
            <div class="free-main-item-right-four">
                <div><img src="../../assets/freeRunning-eye.png" alt="" style="margin-right:5px;"><span>{{item.visitornum}}</span></div>
                <div><img src="../../assets/freeRunning-time.png" alt=""  style="margin-right:5px;margin-top:3px;"><span>{{item.publishedtime}}</span></div>
              </div>
        </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    freeitems: {
      default: () => {
        return []
      },
      type: Array,
      required: true
    }
  },
  methods: {
    detail (id, img) {
      this.$router.push({
        path: '/pastReviewDetail',
        query: {
          free: true,
          id: id,
          img: img
        }
      })
    }
  }
}
</script>
<style scoped>
  .freeRunning-main{
      width:100%;
      display:flex;
      flex-wrap:wrap;
  }
  .free-main-item{
    cursor: pointer;
      display:flex;
      margin-bottom:20px;
      padding-bottom:20px;
      border-bottom:1px solid #eee;
      overflow: hidden;
  }
.free-main-item:hover {
        box-shadow: 0px 0px 12px #ccc9c9;
        transition: all 0.2s;
    }
    .free-main-item:hover img{

            transform: scale(1.02);
            transition: all 0.5s;
    }
  .free-main-item-left{
      width:264px;
      height:176px;
      margin-right:20px;
      position: relative;
  }
  .free-main-item-left-pos{
      position: absolute;
      top:0;left:10px;
  }
  .free-main-item-left img:nth-child(1){
      width:100%;
      height:100%;
  }
  .free-main-item-right{
      display:flex;
      flex-direction: column;
      justify-content: space-between;
      width:318px;
      padding-right:10px;
  }
  .free-main-item-right-one{
      font-size:16px;
      font-weight:bold;
      margin-bottom:9px;
      flex:0 0 16px;
  }
  .free-main-item-right-two{
    flex:0 0 14px;
      font-size: 14px;
      color:#7a7a7a;
      margin-bottom:20px;
  }
  .free-main-item-right-three{
    flex:auto;
      font-size: 14px;
      color:#7a7a7a;
      font-weight:300;
      line-height:22px;

  }
  .free-main-item-right-four{
      font-size: 14px;
      color:#7a7a7a;
      display:flex;
      align-items: center;
      justify-content: space-between;
  }
</style>



// WEBPACK FOOTER //
// src/components/free/free.vue